import { Controller } from "@hotwired/stimulus"

// Profile message bar: show when scrolling down (nav hides), hide when scrolling up.
export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 100 }
  }

  connect() {
    this.lastScrollY = window.scrollY
    this.visible = false
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.setVisible(false, false)
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const currentScrollY = window.scrollY

    if (currentScrollY < this.thresholdValue) {
      this.setVisible(false)
      this.lastScrollY = currentScrollY
      return
    }

    if (currentScrollY > this.lastScrollY && !this.visible) {
      this.setVisible(true)
    } else if (currentScrollY < this.lastScrollY && this.visible) {
      this.setVisible(false)
    }

    this.lastScrollY = currentScrollY
  }

  setVisible(visible, animate = true) {
    this.visible = visible
    this.element.classList.toggle("is-visible", visible)
    this.element.style.transition = animate
      ? "transform 0.3s ease-in-out, opacity 0.3s ease-in-out"
      : "none"
  }
}
